<template>
    <v-container fluid class="ma-0 pa-0">
        <v-overlay :value="isLoading">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <div class="pb-2">
            <h2 class="d-inline">{{ deviceName }}</h2>
        </div>
        <!-- ============================================= -->
        <v-row class="pb-1">
            <!--
            <v-col cols="auto" style="width: 150px">
                <v-menu v-model="dispCalendar" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field label="日付" outlined dense v-model="targetDate" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="targetDate" @input="dispCalendar = false" locale="ja" :max="maxDate" @change="calendarChange()"></v-date-picker>
                </v-menu>
            </v-col>
            -->
            <v-col>
                <v-select label="検出フィルタ" outlined dense v-model="detectFilter" :items="detectFilterItem" @change="registTimelineData()" hide-details>
                    <template v-slot:item="{ item, on, attrs }">
                        <v-list-item ripple v-bind="attrs" v-on="on">
                            <v-list-item-icon style="margin-right: 3px">
                                <v-img :src="item.icon" max-width="20" max-height="20" contain />
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                        <v-img :src="item.icon" max-width="20" max-height="20" contain class="mr-2" />
                        <span>{{ item.text }}</span>
                    </template>
                </v-select>
            </v-col>
            <v-col v-show="detectFilter">
                <v-select label="検出数" outlined dense v-model="detectCount" :items="detectCountItem" @change="registTimelineData()" hide-details></v-select>
            </v-col>
        </v-row>
        <!-- ============================================= -->
        <img :src="jpgImg" :height="imgHeight()" :width="imgWidth()" />
        <v-divider></v-divider>
        <!-- ============================================= -->
        <v-card elevation="24">
            <div style="max-width: 1024px" class="mx-auto">
                <h3 class="text-center">{{ dispCursorTime() }}</h3>
                <v-slider :min="0" :max="86400 - 1" v-model="cursor_time" dense hide-details readonly></v-slider>
                <div class="pa-2">
                    <timeline :imageList="imageList"></timeline>
                </div>
            </div>
        </v-card>
        <v-divider></v-divider>
        <!-- ============================================= -->
        <!--
        <v-card class="text-center py-3">
            <v-btn class="ml-1" color="info" @click="slideChange(-900)"><v-icon>mdi-step-backward-2</v-icon></v-btn>
            <v-btn class="ml-1" color="info" @click="slideChange(-1)"><v-icon>mdi-step-backward</v-icon></v-btn>
            <v-btn class="ml-1" :color="isPlay ? 'error' : 'info'" @click="slidePlay()"><v-icon>mdi-play-pause</v-icon></v-btn>
            <v-btn class="ml-1" color="info" @click="slideChange(1)"><v-icon>mdi-step-forward</v-icon></v-btn>
            <v-btn class="ml-1" color="info" @click="slideChange(900)"><v-icon>mdi-step-forward-2</v-icon></v-btn>
        </v-card>
        -->
        <!-- ============================================= -->
        <v-card class="py-3">
            <div class="mx-auto" style="width: 330px">
                <div class="d-flex justify-center">
                    <v-btn class="mx-1" style="min-width: 60px" color="info" @click="slideChangeBtn(-3600)"><v-icon>mdi-step-backward-2</v-icon></v-btn>
                    <v-btn class="mx-1" style="min-width: 60px" color="info" @click="slideChangeBtn(-1)"><v-icon>mdi-step-backward</v-icon></v-btn>
                    <v-btn class="mx-1" style="min-width: 60px" :color="isPlay ? 'error' : 'info'" @click="slidePlay()"><v-icon>mdi-play-pause</v-icon></v-btn>
                    <v-btn class="mx-1" style="min-width: 60px" color="info" @click="slideChangeBtn(1)"><v-icon>mdi-step-forward</v-icon></v-btn>
                    <v-btn class="mx-1" style="min-width: 60px" color="info" @click="slideChangeBtn(3600)"><v-icon>mdi-step-forward-2</v-icon></v-btn>
                </div>
            </div>
            <div class="mx-auto mt-4" style="width: 332px">
                <div class="d-flex justify-space-between">
                    <v-btn class="mx-0" style="min-width: 80px" color="info" @click="dateChange(-1)"><h3>前日</h3></v-btn>
                    <div>
                        <v-menu v-model="dispCalendar" :close-on-content-click="false" :nudge-top="460" :nudge-left="80" transition="slide-y-reverse-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field style="width: 130px" background-color="info" dark class="text-h6" dense solo v-model="targetDate" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="targetDate" @input="dispCalendar = false" locale="ja" :max="maxDate" @change="calendarChange()"></v-date-picker>
                        </v-menu>
                    </div>
                    <v-btn class="mx-0" style="min-width: 80px" color="info" @click="dateChange(+1)" :disabled="targetDate >= maxDate"><h3>翌日</h3></v-btn>
                </div>
            </div>
        </v-card>
        <!-- ============================================= -->
    </v-container>
</template>

<style scoped>
.navi-orange-on {
    font-weight: bold;
    color: orange; /*文字色*/
    padding: 0.3em 0; /*上下の余白*/
    border-bottom: solid 5px orange; /*線の種類（二重線）太さ 色*/
}
.navi-orange-off {
    font-weight: bold;
    color: #aaaaaa; /*文字色*/
    padding: 0.3em 0; /*上下の余白*/
    border-bottom: solid 5px #dddddd; /*線の種類（二重線）太さ 色*/
}

img {
    background-color: lightgray;
    /* height: 60vh; */
    /* width: auto; */
    /* object-fit: contain; */
    object-fit: contain;
}
.pinch-zoom {
    height: 60vh;
}
</style>

<script>
import Timeline from "@/components/CompTimeline";

export default {
    name: "Playback",
    components: {
        Timeline,
    },
    //#######################################################
    props: {
        device_id: {
            type: Number,
            required: true,
        },
        target_date: {
            type: String,
            required: true,
        },
    },
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            // device_id: null,
            dbDevices: null,
            dbShotLogs: null,
            dbImageList: null,
            detectFilter: "",
            detectFilterItem: [
                { value: "", text: "すべて", icon: null },
                { value: "deer", text: "シカ", icon: require("@/assets/icon-dear.svg") },
                { value: "boar", text: "イノシシ", icon: require("@/assets/icon-boar.svg") },
                { value: "boarlet", text: "ウリ坊", icon: require("@/assets/icon-boarlet.svg") },
                { value: "bear", text: "クマ", icon: require("@/assets/icon-bear.svg") },
                { value: "monkey", text: "サル", icon: require("@/assets/icon-monkey.svg") },
            ],
            detectCount: 1,
            detectCountItem: [
                { value: 1, text: "1以上" },
                { value: 2, text: "2以上" },
                { value: 3, text: "3以上" },
                { value: 4, text: "4以上" },
                { value: 5, text: "5以上" },
            ],
            noImage: require("@/assets/no-image.jpg"),
            cursor_time: 0,
            jpgImg: "",
            imageProps: { blank: true },
            imageList: [],
            jpgSec: 1000,
            dispCalendar: false,
            beforeDate: this.$moment().format("YYYY-MM-DD"),
            targetDate: this.$moment().format("YYYY-MM-DD"),
            maxDate: this.$moment().format("YYYY-MM-DD"),
            isPlay: false,
            aspect: "16:9",
            isLoading: false,
            //-------------------------------------------
            windowWidth: window.innerWidth, // 画面サイズ
            windowHeight: window.innerHeight, //画面サイズ
            //-------------------------------------------
        };
    },
    //#########################################################################################
    created: async function () {
        this.jwt = this.$localStorage.get("user-jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        // this.device_id = this.$route.params.device_id;
        if (this.$route.params.target_date) {
            this.targetDate = this.$route.params.target_date;
        }
        if (this.$route.query.detect) {
            const filter = this.$route.query.detect;
            if (filter == "deer") this.detectFilter = filter;
            if (filter == "boar") this.detectFilter = filter;
            if (filter == "boarlet") this.detectFilter = filter;
            if (filter == "bear") this.detectFilter = filter;
            if (filter == "monkey") this.detectFilter = filter;
        }
        //---------------------------------
        this.isLoading = true;
        //---------------------------------
        const promiseDevices = this.axiosGetDevices();
        const promiseShotLogs = this.axiosGetShotLogs();
        const promiseImageList = this.axiosGetImageList();
        await promiseDevices;
        await promiseShotLogs;
        await promiseImageList;
        this.registTimelineData();
        //---------------------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //---------------------------------
    },
    //#########################################################################################
    mounted: function () {
        window.addEventListener("resize", this.handleResize);
    },
    //#########################################################################################
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    },
    //#########################################################################################
    watch: {
        $route: async function (to, from) {
            if (from.fullPath !== to.fullPath) {
                this.device_id = to.params.device_id;
                await this.axiosGetDevices();
                await this.axiosGetShotLogs();
                await this.axiosGetImageList();
            }
        },
        target_date(newDate, oldDate) {
            this.beforeDate = oldDate;
            this.targetDate = newDate;
            this.calendarChange();
        },
        // targetDate(newDate, oldDate) {
        //     this.beforeDate = oldDate;
        //     this.calendarChange();
        // },
    },
    //#########################################################################################
    computed: {
        deviceName: function () {
            let ret = "";
            for (let idx in this.dbDevices) {
                let id = this.dbDevices[idx].id;
                if (id == this.device_id) ret = this.dbDevices[idx].name;
            }
            return ret;
        },
    },
    //#########################################################################################
    methods: {
        //====================================================
        handleResize: function () {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        //====================================================
        imgHeight: function () {
            let ret = "100%";
            if (this.windowHeight < this.windowWidth * 1.5) {
                let val = this.windowHeight - 450;
                if (val < 50) val = 50;
                ret = val;
            }
            return ret;
        },
        //====================================================
        imgWidth: function () {
            let ret = "100%";
            if (this.windowHeight < this.windowWidth * 1.5) {
                let val = this.windowWidth - 40;
                if (val < 50) val = 50;
                ret = val;
            }
            return ret;
        },
        //====================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: {
                    id: this.device_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
            });
        },
        //====================================================
        async axiosGetShotLogs() {
            //----------------------------------
            const sdate = this.targetDate;
            const edate = this.$moment(sdate).add(1, "days").format("YYYY-MM-DD");
            //----------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/shot_logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: {
                    "received_at[EQGREAT]": sdate,
                    "received_at[SMALL]": edate,
                    device_id: this.device_id,
                },
                timeout: 10000,
            }).then((response) => {
                this.dbShotLogs = response.data.json;
            });
            //-------------------------------
        },
        //====================================================
        async axiosGetImageList() {
            // await new Promise((r) => setTimeout(r, 1000));
            await this.axios({
                method: "GET",
                url: "/web/api/rapid-image-list/" + this.device_id + "/" + this.targetDate,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            })
                .then((response) => {
                    this.dbImageList = response.data.json;
                })
                .catch((err) => {
                    const { status, statusText } = err.response;
                    alert(status + " : " + statusText);
                });
        },
        //====================================================
        registTimelineData() {
            this.imageList = new Array(86400).fill("");
            if (this.dbShotLogs.length == 0) {
                this.jpgImg = this.noImage;
            }
            for (const shotlog of this.dbShotLogs) {
                const dt = shotlog["received_at"];
                const strJson = shotlog["ai_analyzed"];
                //------------------------------------------
                if (this.detectFilter) {
                    if (strJson != null && strJson != "[]") {
                        const detections = JSON.parse(strJson);
                        let ct = 0;
                        for (const detect of detections) {
                            const animal = detect["class"];
                            if (animal == this.detectFilter) {
                                ct++;
                                if (ct >= this.detectCount) {
                                    let hh = this.$moment(dt).hours();
                                    let mm = this.$moment(dt).minute();
                                    let ss = this.$moment(dt).second();
                                    let aryNo = hh * 3600 + mm * 60 + ss;
                                    this.imageList[aryNo] = dt;
                                }
                            }
                        }
                        if (ct == 0) {
                            this.jpgImg = this.noImage;
                        }
                    }
                } else {
                    let hh = this.$moment(dt).hours();
                    let mm = this.$moment(dt).minute();
                    let ss = this.$moment(dt).second();
                    let aryNo = hh * 3600 + mm * 60 + ss;
                    this.imageList[aryNo] = dt;
                }
                //------------------------------------------
            }
            if (this.beforeDate > this.targetDate) {
                this.cursor_time = 86400 - 1; // 指定日の最後の画像へ
                this.slideChange(-1); // 指定日の最後の画像へ
            } else {
                this.cursor_time = 0; // 指定日の最後の画像へ
                this.slideChange(1); // 指定日の最後の画像へ
            }
        },
        // registTimelineData() {
        //     this.imageList = new Array(86400).fill("");
        //     let dateAry = this.dbImageList;
        //     for (let i in dateAry) {
        //         let hh = this.$moment(dateAry[i]).hours();
        //         let mm = this.$moment(dateAry[i]).minute();
        //         let ss = this.$moment(dateAry[i]).second();
        //         let aryNo = hh * 3600 + mm * 60 + ss;
        //         this.imageList[aryNo] = dateAry[i];
        //     }
        //     // this.cursor_time = 86400 - 1; // 指定日の最後の画像へ
        //     // this.slideChange(-1); // 指定日の最後の画像へ
        //     this.cursor_time = 0; // 指定日の最後の画像へ
        //     this.slideChange(1); // 指定日の最後の画像へ
        // },
        //====================================================
        async dateChange(dVal) {
            if (this.targetDate >= this.maxDate && dVal >= 1) {
                return true;
            }
            this.beforeDate = this.targetDate;
            this.targetDate = this.$moment(this.targetDate).add(dVal, "day").format("YYYY-MM-DD");
            this.calendarChange();
        },
        //====================================================
        async calendarChange() {
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 300));
            const promiseShotLogs = this.axiosGetShotLogs();
            const promiseImageList = this.axiosGetImageList();
            await promiseShotLogs;
            await promiseImageList;
            this.registTimelineData();
            this.isLoading = false;
            this.isPlay = false;
        },
        //====================================================
        slidePlay: async function () {
            if (this.isPlay == true) {
                this.isPlay = false;
            } else {
                this.isPlay = true;
                while (this.isPlay) {
                    await this.slideChange(+1);
                    await new Promise((r) => setTimeout(r, 300));
                    if (this.cursor_time > 86400 - 100) this.isPlay = false;
                }
            }
        },
        //====================================================
        slideChangeBtn: async function (seconds) {
            let nextCursor = Number(this.cursor_time) + Number(seconds);
            while (0 < nextCursor && nextCursor < 86400) {
                if (this.imageList[nextCursor]) break;
                if (seconds == 0) break;
                if (seconds > 0) nextCursor++;
                else nextCursor--;
            }
            if (nextCursor <= 0) {
                this.dateChange(-1); //ボタン操作に限り、画像が無い場合は前日へ(無限ループ対策)
                return true;
            }
            if (nextCursor > 86400 - 1) {
                this.dateChange(+1); //ボタン操作に限り、画像が無い場合は翌日へ(無限ループ対策)
                return true;
            }
            this.cursor_time = nextCursor;
            this.getImage();
        },
        //====================================================
        slideChange: async function (seconds) {
            let nextCursor = Number(this.cursor_time) + Number(seconds);
            while (0 < nextCursor && nextCursor < 86400) {
                if (this.imageList[nextCursor]) break;
                if (seconds == 0) break;
                if (seconds > 0) nextCursor++;
                else nextCursor--;
            }
            if (nextCursor <= 0) {
                return true;
            }
            if (nextCursor > 86400 - 1) {
                return true;
            }
            this.cursor_time = nextCursor;
            this.getImage();
            //await new Promise(r => setTimeout(r, 5000));
        },
        //====================================================
        dispCursorTime: function () {
            const hh = (this.cursor_time / 3600) | 0; // 小数点切り捨て
            const mm = ((this.cursor_time - hh * 3600) / 60) | 0; // 小数点切り捨て
            const ss = this.cursor_time % 60; // 余り
            return ("00" + hh).slice(-2) + ":" + ("00" + mm).slice(-2) + ":" + ("00" + ss).slice(-2);
        },
        //====================================================
        async getImage() {
            this.isLoading = true;
            const jpgKey = this.imageList[this.cursor_time];
            if (!jpgKey) {
                this.jpgImg = this.noImage;
                this.imageProps = { blank: true, width: 16, height: 9 };
                return false;
            } else {
                this.imageProps = { blank: false };
            }
            this.axios({
                responseType: "blob",
                method: "GET",
                url: "/web/api/rapid-image/" + this.device_id + "/" + jpgKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            })
                .then((response) => {
                    //-----------------------------------------
                    //this.jpgImg = window.URL.createObjectURL(response.data);
                    //-----------------------------------------
                    const strJson = this.getAnalyzedJson(this.device_id, jpgKey);
                    // self.console.log({ jpgKey, strJson });
                    this.blobToImage(response.data, strJson);
                })
                .catch((err) => {
                    console.log(err);
                    // const { status, statusText } = err.response;
                    // alert(status + " : " + statusText);
                });
            // await new Promise((r) => setTimeout(r, 100));
            this.isLoading = false;
        },
        //====================================================
        getAnalyzedJson(device_id, received_at) {
            let ret = "[]";
            for (const shotlog of this.dbShotLogs) {
                if (device_id == shotlog.device_id) {
                    if (this.$moment(received_at).format() == this.$moment(shotlog.received_at).format()) {
                        ret = shotlog.ai_analyzed;
                    }
                }
            }
            return ret;
        },
        //====================================================
        blobToImage(blob, strJson) {
            //const blob = response.data;
            const img = new Image();
            //-----------------------------------------
            img.onload = () => {
                // Canvas を作成
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0); // 画像をCanvasに描画
                //-----------------------
                if (strJson != null && strJson != "[]") {
                    const detections = JSON.parse(strJson);
                    for (const detect of detections) {
                        const species = detect["class"];
                        const bbox = detect["bbox"];
                        const score = detect["score"];
                        const xx = bbox[0];
                        const yy = bbox[1];
                        const ww = bbox[2] - bbox[0];
                        const hh = bbox[3] - bbox[1];
                        //-----------------------
                        let ctxColor = null;
                        if (species == "deer") ctxColor = "rgba(0, 250, 0, 1)";
                        else if (species == "boar") ctxColor = "rgba(100, 200, 240, 1)";
                        else if (species == "boarlet") ctxColor = "rgba(200, 100, 240, 1)";
                        //else if (species == "all") ctxColor = "rgba(250, 0, 0, 1)";
                        else continue;

                        const ctxStr = String(Math.round(score * 100)) + "% : " + species;
                        ctx.strokeStyle = ctxColor;
                        ctx.lineWidth = 7; //線の太さ
                        ctx.beginPath();
                        ctx.strokeRect(xx, yy, ww, hh);
                        ctx.stroke();
                        //-----------------------
                        ctx.font = "35px Arial"; //ctx.font = '30px Impact';
                        //ctx.fillStyle = "blue";
                        //ctx.strokeText(ctxStr, xx, yy - 10);
                        ctx.fillStyle = ctxColor;
                        ctx.fillText(ctxStr, xx, yy - 10);
                    }
                }
                //-----------------------
                canvas.toBlob((processedBlob) => {
                    this.jpgImg = URL.createObjectURL(processedBlob);
                }, "image/jpeg");
            };
            //-----------------------------------------
            // Blob を一時URLに変換して Image に設定
            img.src = URL.createObjectURL(blob);
            //-----------------------------------------
        },
        //====================================================
    },
};
</script>
